<div class="conn-card" *ngIf="1 == 1">
    <app-report-top-filter-bar
        [paraReportName]="'inventory-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="dt.exportCSV()"
    >
    </app-report-top-filter-bar>

    <div class="inventory-table-toolbar" *ngIf="!isLoading && dataList?.length > 0 && hasVariantGroups">
        <div class="inventory-group-actions" *ngIf="hasVariantGroups">
            <p-button
                styleClass="p-button-text p-button-sm"
                label="Expand all variants"
                [disabled]="areAllVariantGroupsExpanded"
                (onClick)="setAllGroupsExpanded(true)"
            ></p-button>
            <p-button
                styleClass="p-button-text p-button-sm"
                label="Collapse all variants"
                [disabled]="!areAllVariantGroupsExpanded"
                (onClick)="setAllGroupsExpanded(false)"
            ></p-button>
        </div>
    </div>

    <p-table
        #dt
        [columns]="csvcols"
        styleClass="p-datatable-striped"
        id="table-001"
        [autoLayout]="true"
        [tableStyle]="{ width: 'max-content' }"
        [value]="isLoading ? skeletonRows : (groupedDataList || [])"
        responsiveLayout="scroll"
        showLoader="true"
        rowHover="true"
        [customSort]="true"
        [lazy]="true"
        (onLazyLoad)="customSort($event)"
        [lazy]="true"
        (onLazyLoad)="customSort($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <!-- <th pSortableColumn="locationName">
                    Location <p-sortIcon field="locationName"></p-sortIcon>
                </th> -->
                <th
                    *ngIf="_abd.locations.length > 1"
                    pSortableColumn="locationName"
                >
                    Location
                </th>
                <!-- <th>Department</th> -->
                <th pSortableColumn="itemName">
                    <p-sortIcon field="itemName"></p-sortIcon> Product
                </th>
                <th pSortableColumn="barcode">
                    <p-sortIcon field="barcode"></p-sortIcon> Barcode
                </th>
                <th pSortableColumn="skuCode">
                    <p-sortIcon field="skuCode"></p-sortIcon> SKU
                </th>
                <th class="number-header">Opening Qty</th>
                <th class="number-header">Purchases</th>
                <th class="number-header">Transfers Out</th>
                <th class="number-header">Transfers In</th>
                <th class="number-header">Damaged</th>
                <th class="number-header">Sold</th>
                <th class="number-header">Closing Qty</th>
                <th class="number-header" title="Quantity on hand">
                    Qty on Hand
                </th>
                <!-- <th style="text-align: center"pSortableColumn="itemName" ><p-sortIcon field="itemName"></p-sortIcon>Variance</th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr *ngIf="isLoading; else dataRow" class="text-center">
                <td *ngIf="_abd.locations.length > 1">
                    <p-skeleton width="8rem" height="1rem"></p-skeleton>
                </td>
                <td><p-skeleton width="10rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="8rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="7rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
            </tr>
            <ng-template #dataRow>
                <tr class="text-center" [class.inventory-group-row]="item._rowType === 'group'" [class.inventory-child-row]="item._rowType === 'item'">
                    <td *ngIf="_abd.locations.length > 1">
                        <span *ngIf="item._rowType !== 'item'">{{ item.locationName }}</span>
                        <span *ngIf="item._rowType === 'item'">-</span>
                    </td>
                    <td [title]="item.itemName">
                        <div class="inventory-product-cell">
                            <ng-container *ngIf="item._rowType === 'group'">
                                <button
                                    *ngIf="item._isVariant"
                                    type="button"
                                    class="inventory-expand-btn"
                                    [class.inventory-expand-btn-expanded]="item._isExpanded"
                                    (click)="toggleGroup(item, $event)"
                                >
                                    {{ item._isExpanded ? 'v' : '>' }}
                                </button>
                                <span *ngIf="!item._isVariant" class="inventory-expand-btn-placeholder" aria-hidden="true"></span>
                            </ng-container>
                            <span class="inventory-product-name" [class.inventory-product-name-child]="item._rowType === 'item'">
                                <span
                                    [class.inventory-product-name-toggleable]="item._rowType === 'group' && item._isVariant"
                                    (click)="item._rowType === 'group' && item._isVariant ? toggleGroup(item, $event) : null"
                                >
                                    {{ item.itemName }}
                                </span>
                            </span>
                            <span
                                *ngIf="item._rowType === 'group' && item._isVariant"
                                class="inventory-type-badge"
                                [class.inventory-type-badge-variant]="item._isVariant"
                                [class.inventory-type-badge-simple]="!item._isVariant"
                            >
                                {{ 'Variant x' + item._variantCount }}
                            </span>
                        </div>
                    </td>
                    <!-- <td>{{ item.department }}</td> -->
                    <td [class.inventory-na-cell]="!getGroupTextValue(item, 'barcode')">{{ getGroupTextValue(item, 'barcode') }}</td>
                    <td [class.inventory-na-cell]="!getGroupTextValue(item, 'skuCode')">{{ getGroupTextValue(item, 'skuCode') }}</td>

                    <td class="number-cell">{{ formatQuantity(item.openingStock) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.purchase) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.transferOut) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.transerIn) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.damage) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.usedSince) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.closingStock) }}</td>
                    <td class="number-cell">{{ formatQuantity(item.computedStockInHand) }}</td>
                    <!-- <td style="text-align: center">{{ item.variance }}</td> -->
                </tr>
            </ng-template>
        </ng-template>
    </p-table>
    <div class="grid" *ngIf="!isLoading && dataList?.length == 0">
        <div class="text-align-center col-12" style="width: 100%">
            <span class="control-description text-muted text-align-center">
                No data found for selected filters.
            </span>
            <br />
            <br />
        </div>
        <div class="text-align-center col-12" style="width: 100%">
                   <p-button
                        label="Click to add product"
                        (onClick)="_router.navigate(['app/new-product'])"
                    >
                    </p-button>

            
        </div>
    </div>
    <p-paginator
        #p
        [first]="first"
        *ngIf="!isLoading && dataList?.length > 0"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
    ></p-paginator>
</div>

<p-sidebar
    *ngIf="gProductId"
    header="Item"
    [(visible)]="gProductId"
    [fullScreen]="true"
    class="productviewsidebar"
>
    <app-product-view-only [GID]="gProductId"></app-product-view-only>
</p-sidebar>
